<h2 mat-dialog-title>Offer Sentence</h2>
<mat-dialog-content class="text-left">


</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>Back</button>
</mat-dialog-actions>
